import c from "../common";

export default {
  title: c.takeaway.chn,
  description_1: "外賣單",
  description_2: "菜單",
  description_3: "設定",

  mon: c.weekday.mon.chn,
  tue: c.weekday.tue.chn,
  wed: c.weekday.wed.chn,
  thu: c.weekday.thu.chn,
  fri: c.weekday.fri.chn,
  sat: c.weekday.sat.chn,
  sun: c.weekday.sun.chn,

  message_1: "配額為必填",
  message_2: "請填寫標題",
  message_3: "請填寫餐飲名稱",
  message_4: "請選擇餐飲價錢",
  message_5: "餐飲名稱不可重覆",
  message_6: "全部截單",
  message_7: "上次更新:",
  message_8: "目前流水號:",
  message_9: "已下單",
  message_10: "已提取",
  message_11: "餐飲:",
  message_12: "第",
  message_13: "個餐:",
  message_14: "不加餐飲",
  message_15: "備註:",
  message_16: "請選擇外賣劵...",
  message_17: "的菜單",
  message_18: "+ 增加餐款",
  message_19: "最多只可有{{max}}項選擇",
  message_20: "增加/修改餐款",
  message_21: "圖片",
  message_22: "選填, 圖片比例1:1",
  message_23: "配額",
  message_24: "食品描述",
  message_25: "無法增加更多",
  message_26: "+ 增加",
  message_27: "請選擇",
  message_28: "只提供熱",
  message_29: "只提供凍",
  message_30: "提供熱凍",
  message_31: "取消截單",
  message_32: "截單",
  message_33: "修改",
  message_34: "剩餘:",
  message_35: "不提供外賣自取服務",
  message_36: " 至 ",
  message_37: "標題",
  message_38: "價錢",


  open: "開啟",
  close: "關閉",
  reset: "重設",
  today: "今天",
  past: "過往",
  na: "暫無",
  confirm: "確定",
  save: "儲存",
  copy: "複製",
  paste: "貼上",
};
